import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ElementRef,
  HostListener,
} from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { Observable, Subject } from "rxjs";
import { filter, takeUntil, tap } from "rxjs/operators";
import { INavItem } from "app/interfaces/index";

import { UiService } from "@services/ui/ui.service";

@Component({
  selector: "aff-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["./navigation.component.scss"],
})
export class NavigationComponent implements OnInit, OnDestroy {
  @Input() navigation: any;

  public activeUrl: string;
  public openUrl: string;
  public redirectedUrl: string;

  private unsubscribe$ = new Subject<void>();

  @HostListener("document:click", ["$event"])
  private clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.openUrl = "";
    }
  }

  constructor(
    private router: Router,
    private uiService: UiService,
    private eRef: ElementRef
  ) {
    this.router.events
      .pipe(
 
        takeUntil(this.unsubscribe$),
        filter((event) => event instanceof NavigationEnd),
        tap((event: NavigationEnd) => (this.activeUrl = event.url)),
        tap((event: NavigationEnd) => (this.openUrl = "")),
      )
      .subscribe(
        (x =>  (this.activeUrl = x.urlAfterRedirects)) 
      );

  }

  ngOnInit(): void {}
  


  navClick(item: INavItem) {
    item.children ? this.onClickItem(item) : this.goToPage(item);
  }

  private goToPage(item: INavItem) {
    this.router.navigate([item.url]);
    console.log('item url', item.url)
  }

  private onClickItem(item: INavItem) {
    this.openUrl = item.url;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
